import { createSelector } from '@reduxjs/toolkit';

// Base selectors
export const selectNavigationState = state => state.navigation;

export const selectBreadcrumbs = state => state.navigation.breadcrumbs;

export const selectCurrentRoute = state => state.navigation.currentRoute;

export const selectIsNavigating = state => state.navigation.isNavigating;

export const selectNavigationError = state => state.navigation.navigationError;

// Computed selectors
export const selectCurrentBreadcrumb = createSelector(
  [selectBreadcrumbs],
  breadcrumbs => breadcrumbs[breadcrumbs.length - 1] || null
);

export const selectPreviousBreadcrumb = createSelector(
  [selectBreadcrumbs],
  breadcrumbs => breadcrumbs[breadcrumbs.length - 2] || null
);

export const selectBreadcrumbsCount = createSelector(
  [selectBreadcrumbs],
  breadcrumbs => breadcrumbs.length
);

export const selectCanGoBack = createSelector([selectBreadcrumbsCount], count => count > 1);

export const selectBreadcrumbByIndex = index =>
  createSelector([selectBreadcrumbs], breadcrumbs => breadcrumbs[index] || null);

export const selectBreadcrumbsForDisplay = createSelector([selectBreadcrumbs], breadcrumbs =>
  breadcrumbs.map((item, index) => ({
    ...item,
    isLast: index === breadcrumbs.length - 1,
    index,
  }))
);

// Get breadcrumb path as string for comparison
export const selectCurrentPath = createSelector(
  [selectCurrentRoute],
  currentRoute => currentRoute?.path || null
);

// Check if we're on a specific route
export const selectIsOnRoute = routePath =>
  createSelector([selectCurrentPath], currentPath => currentPath === routePath);

// Get route params
export const selectCurrentRouteParams = createSelector(
  [selectCurrentRoute],
  currentRoute => currentRoute?.params || {}
);

// Get specific route param
export const selectRouteParam = paramName =>
  createSelector([selectCurrentRouteParams], params => params[paramName] || null);

// Navigation state summary
export const selectNavigationSummary = createSelector(
  [selectBreadcrumbs, selectCurrentRoute, selectIsNavigating, selectNavigationError],
  (breadcrumbs, currentRoute, isNavigating, navigationError) => ({
    breadcrumbs,
    currentRoute,
    isNavigating,
    hasError: !!navigationError,
    error: navigationError,
    breadcrumbsCount: breadcrumbs.length,
    canGoBack: breadcrumbs.length > 1,
  })
);
